import { Button, Card, Checkbox, Form, Input, InputNumber, message, Select, Spin } from 'antd';
import React from 'react';
import { getFormFieldByType, sanitizeFieldName } from '../../util/methods';
// import CountryPhoneInput, { ConfigProvider } from 'antd-country-phone-input';
import en from 'world_countries_lists/data/countries/en/world.json';
import moment from 'moment-timezone';

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allClientAccess: false,
      allLocationAccess: false,
    }
  }

  componentDidMount() {
    const { match, fetch, data } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    this.setState({
      allLocationAccess: data && data['allLocationAccess'],
      allClientAccess: data && data['allClientAccess']
    })
  }

  componentWillReceiveProps(nextProps, nextContext) {

    if (nextProps.data && nextProps.data['allLocationAccess'] !== this.props.data['allLocationAccess']) {
      this.setState({ allLocationAccess: nextProps.data['allLocationAccess'] });
    }
    if (nextProps.data && nextProps.data['allClientAccess'] !== this.props.data['allClientAccess']) {
      this.setState({ allClientAccess: nextProps.data['allClientAccess'] });
    }

    if (nextProps.data && nextProps.data.organisation && JSON.stringify(nextProps.data.organisation) !== JSON.stringify(this.props.data.organisation)) {
      this.props.getOrgRoles(nextProps.data.organisation._id)
    }
  }


  handleSubmit = (e) => {
    const { match, form, data, filters, authUser } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      if (!authUser.superAdmin) {
        const superAdminRoles = data && data.roles && data.roles.filter(item => filters['roles'].data.data.find(elem => elem._id === item._id) ? false : true);
        const arr = (superAdminRoles || []).map(item => item._id);
        values['roles'] = [...new Set([...values['roles'], ...arr])];
      }

      if (values && values.phoneNumber) {
        const phn = parseInt(values.phoneNumber);
        if (phn.toString().length !== 10)
          return message.error('Phone Number should be of 10 digits');
        values.phoneNumber = {
          code: '91',
          phone: phn,
          short: 'IN'
        }
      }

      // When the Reporting Supervisor is cleared in the UI its value becomes
      // undefined, which JSON drops from the payload — so the backend $set never
      // clears it. Send an explicit null so it is removed on save.
      if (Object.prototype.hasOwnProperty.call(values, 'supervisor') && !values.supervisor) {
        values.supervisor = null;
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  handleChange = (stateVal, e) => {
    this.setState({ [stateVal]: e.target.checked });
  };

  handleOrganisationChange = (org) => {
    // console.log(org);
    if (org) {
      this.props.getOrgRoles(org);
    }
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { data, loading, filters, title, resource, authUser, orgRoles } = this.props;
    const { allLocationAccess, allClientAccess } = this.state;
    let isAdmin = false; // (roles || []).findIndex(item => item.role === 'Org Admin') >= 0;
    const rolesInitialValue = [];
    filters['roles'] && filters['roles'].data && data['roles'] && data['roles'].length && data['roles'].map(field => {
      const kk = filters['roles'].data.data.find(item => item._id === field._id)
      if (kk) {
        // console.log(kk.role)
        isAdmin = (kk.role === 'Org Admin');
        rolesInitialValue.push(kk._id)
      }
    })
    // console.log(orgRoles);
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${resource}`}>
          {/* <ConfigProvider locale={en}> */}
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (item === 'password') {
                return <Form.Item key={'password'} label={'Password'}>
                  {getFieldDecorator('password', {
                    rules: [
                      { required: !(this.props.match.params && this.props.match.params.id), message: 'Please input your password!' },
                      { min: 6, max: 28, message: 'Password must be between 6 and 28 characters' },
                    ],
                    initialValue: '',
                  })(
                    <Input type="password" placeholder="Password" />,
                  )}
                </Form.Item>;
              }
              if (item === 'locations') {
                if (authUser && !authUser.superAdmin) {
                  return <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [{ required: filters[item].required, message: `${sanitizeFieldName(item)} is required!` }],
                      initialValue: (data['locations'] && data['locations'].length) ? data['locations'].map(field => field._id) : [],
                    })(<Select
                      mode="multiple"
                      disabled={allLocationAccess}
                      style={{ width: '100%' }}
                      placeholder="Please select"
                    >
                      {filters[item].data.data.map(item => <Select.Option key={item._id}
                        value={item._id}>{item.role ? item.role : item.name}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>;
                }
                return;
              }

              if (item === 'organisation' && !getFieldValue('superAdmin')) {
                if (authUser && authUser.superAdmin) {
                  return <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [{ required: filters[item].required, message: `${sanitizeFieldName(item)} is required!` }],
                      initialValue: data['organisation'] && data['organisation'] && data['organisation']._id,
                    })(<Select
                      showSearch
                      filterOption={(input, option) =>
                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onChange={this.handleOrganisationChange}
                      disabled={title !== 'CREATE'}
                    >
                      {filters[item].data.data.map(item => <Select.Option key={item._id}
                        value={item._id}>{item.role ? item.role : item.name}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>;
                }
                return;
              }


              if (item === 'allLocationAccess') {
                if (authUser && !authUser.superAdmin) {
                  return <Form.Item key={item} label={sanitizeFieldName(item)}>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: filters[item].required,
                        message: `${sanitizeFieldName(item)} is required!`
                      }],
                      onChange: this.handleChange.bind(this, 'allLocationAccess'),
                      valuePropName: 'checked',
                      initialValue: !!data['allLocationAccess'],
                    })(<Checkbox />)
                    }
                  </Form.Item>
                }
                return;
              }
              if (item === 'clients') {
                if (authUser && !authUser.superAdmin) {
                  return <Form.Item key={item}
                    label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: filters[item].required,
                        message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
                      }],
                      initialValue: (data['clients'] && data['clients'].length) ? data['clients'].map(field => field._id) : [],
                    })(<Select
                      mode="multiple"
                      disabled={allClientAccess}
                      style={{ width: '100%' }}
                      placeholder="Please select"
                    >
                      {filters[item].data.data.map(item => <Select.Option key={item._id}
                        value={item._id}>{item.role ? item.role : item.name}</Select.Option>)}
                    </Select>)
                    }
                  </Form.Item>;
                }
                return;
              }
              if (item === 'allClientAccess') {
                if (authUser && !authUser.superAdmin) {
                  return <Form.Item key={item}
                    label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                    {getFieldDecorator(item, {
                      rules: [{
                        required: filters[item].required,
                        message: `${sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)} is required!`
                      }],
                      onChange: this.handleChange.bind(this, 'allClientAccess'),
                      valuePropName: 'checked',
                      initialValue: !!data['allClientAccess'],
                    })(<Checkbox />)
                    }
                  </Form.Item>
                }
                return;
              }
              if (item === 'superAdmin') {
                if (authUser && authUser.superAdmin) {
                  return getFormFieldByType(filters, item, getFieldDecorator, data);
                }
                return;
              }

              if (item === 'roles') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${sanitizeFieldName(item)} is required!` }],
                    initialValue: rolesInitialValue,
                  })(<Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    disabled={isAdmin}
                  >
                    {(authUser && authUser.superAdmin) ?
                      (orgRoles || []).map(item =>
                        <Select.Option key={item._id}
                          value={item._id}>{item.role ? item.role : item.name}</Select.Option>)
                      :
                      filters[item].data.data.map(item =>
                        <Select.Option key={item._id}
                          value={item._id}>{item.role ? item.role : item.name}</Select.Option>)
                    }
                  </Select>)
                  }
                </Form.Item>;
              }

              if (item === 'supervisor') {
                const supervisorOptions = (filters[item] && filters[item].data && filters[item].data.data) || [];
                return <Form.Item key={item} label={'Reporting Supervisor'}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: 'Reporting Supervisor is required!' }],
                    initialValue: data['supervisor'] && data['supervisor']._id,
                  })(<Select
                    showSearch
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select a supervisor"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                  >
                    {supervisorOptions
                      // A user cannot be their own supervisor.
                      .filter(u => !(data && data._id && u._id === data._id))
                      .map(u => <Select.Option key={u._id} value={u._id}>{u.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>;
              }

              if (item === 'timezone') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${sanitizeFieldName(item)} is required!` }],
                    initialValue: data['timezone'] && data['timezone'],
                  })(<Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                  >
                    {moment.tz.names().map(item =>
                      <Select.Option key={item}
                        value={item}>{item}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>;
              }
              console.log(item);
              return getFormFieldByType(filters, item, getFieldDecorator, data);
            })}

            <div style={{ marginTop: '20px' }}>
              <Form.Item label={'Phone Number'}>
                {getFieldDecorator("phoneNumber", {
                  rules: [{
                    required: false,
                    message: 'Phone Number is Required'
                  }],
                  initialValue: data && data['phoneNumber'] && data['phoneNumber']['phone']
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </div>
            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
          {/* </ConfigProvider> */}
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
